require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-civil-rights-champion.json") })
        }
      }, "path---es-articles-tags-civil-rights-champion");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-civil-rights-champion!./.cache/json/es-articles-tags-civil-rights-champion.json
// module id = 2245
// module chunks = 231608221292675